import { useQuery } from "react-query";
import { customerUpdate } from "@/repositories/customerUpdates";
import { CustomerUpdate } from "@/types/v2";

interface UseCustomerUpdateByIdParams {
  shopId: string | undefined;
  customerUpdateId: string | undefined;
  enabled?: boolean;
}

export const useCustomerUpdateById = ({
  shopId,
  customerUpdateId,
  enabled = true,
}: UseCustomerUpdateByIdParams) => {
  return useQuery({
    queryKey: ["customerUpdate", shopId, customerUpdateId],
    queryFn: async (): Promise<CustomerUpdate | undefined> => {
      if (!shopId || !customerUpdateId) {
        return undefined;
      }

      return customerUpdate.get(shopId, customerUpdateId);
    },
    enabled: enabled && !!shopId && !!customerUpdateId,
    staleTime: 30 * 1000, // Cache for 30 seconds
    cacheTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
};
